if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        /** Form validation
         *
         *  Validate the form (elements) via AJAX calls
         *
         *  Expects:
         *  <form data-interaction="FormValidation" data-validation-url="ADDRESS/FOR/VALIDATION">
         *  For inputs to be validated within the form:
         *  <input data-validate>
         *  <input type="radio" data-validate-radiogroup>
         *
         *  form can have the following attributes for configuration:
         *  - data-only-validate-if - define exclusion conditions when not to validate.
         *                            multiple exclusions are separated with || (works as OR)
         *  om validation te omzijlen voegen wij data-validation-ignore toe op de button welke het form submit
         */
        ZZ.FormValidation = function(form) {
            var base = this;

            base.form = form || $();
            base.inputs = base.form.find("[data-validate]");
            base.url = base.form.attr("data-validation-url");
            base.method = base.form.attr("data-validation-method-type");
            base.submitBtn = base.form.find("[type=submit]");
            base.checkboxgroups = base.form.find(
                "[data-validate-checkboxgroup]"
            );
            base.config = $.extend(
                {},
                base._defaultConfig,
                base.form.data(),
                base.url
            );
            var exclusions = $("[data-only-validate-if]");
            if (exclusions.length > 0) {
                base.handleExclusionConditions(exclusions);
            }

            base.assignListeners();
            base.previousInvalidFieldValue = "";
            base.previousInvalidFieldTrigger = false;
        };

        ZZ.FormValidation.prototype = {
            _defaultConfig: {
                invalidClassName: "error",
                validClassName: "accord",
                invalidRadiogroupText: "Dit is een verplicht veld."
            },

            assignListeners: function() {
                var base = this;

                base.inputs
                    .not(".hasDatepicker, select")
                    .on("blur.validate", function() {
                        base.transformBeforeValidate($(this));
                        base.validateField($(this));
                    });

                // validate datepickers and selectboxes on change in stead of on blur
                base.form.on(
                    "change",
                    ".hasDatepicker[data-validate], select[data-validate]",
                    function() {
                        base.transformBeforeValidate($(this));
                        base.validateField($(this));
                    }
                );

                base.form
                    .find("[data-validate-radiogroup]")
                    .find("input")
                    .on("change", function() {
                        $(this)
                            .parent()
                            .removeClass("error");
                    });

                // know which submit button is clicked
                base.submitBtn.on("click", function() {
                    $('input[type=hidden][id*="submit_"]').each(function(
                        index
                    ) {
                        $(this).remove();
                    });

                    var submitButton = $(this);
                    var newHiddenInput = $(
                        'input[type=hidden][name="' +
                            submitButton.attr("name") +
                            '"]'
                    );
                    if (newHiddenInput.length === 0) {
                        newHiddenInput = $(
                            '<input type="hidden" value="' +
                                submitButton.val() +
                                '" name="' +
                                submitButton.attr("name") +
                                '" data-info="pass-clicked-submit-btn-value created-dynamically-by-formvalidation-js" />'
                        );
                        base.form.append(newHiddenInput);
                    }
                    newHiddenInput.val(submitButton.val());
                });

                // remove validation when inputs are hidden (e.g. closed by toggle script)
                base.inputs.on("ZZ_input_hidden", function(e) {
                    var input = $(e.currentTarget);
                    base.removeFieldValidation(input);
                });

                base.form.on("submit", function(e) {
                    //om validation te omzijlen voegen wij data-validation-ignore toe op de button welke het form submit
                    if (
                        !$(this)
                            .find("[type=submit]:focus")
                            .attr("data-validation-ignore")
                    ) {
                        e.preventDefault();

                        // check radiogroups
                        var isValid_Radiogroups = base.validateRadioGroups();

                        var submitForm = this;

                        // also send disabled options when selected (first hidden option in selectbox) for validation
                        var selectedDisabledOptions = base.form.find(
                            "select:visible option:disabled:selected"
                        );
                        selectedDisabledOptions.prop("disabled", false);

                        // also send disabled inputs when visible
                        var disabledVisibleInputs = base.form
                            .find(":input:disabled:visible")
                            .not("[type=submit]");
                        disabledVisibleInputs.prop("disabled", false);

                        var data = base.form
                            .find(":input:visible, input[type=hidden]")
                            .serialize();

                        // check whole form for validation errors before submit
                        var curSubmitBtn;
                        base.submitBtn.each(function() {
                            curSubmitBtn = $(this);

                            if (curSubmitBtn.prop("disabled") === false) {
                                curSubmitBtn.prop("disabled", true);
                                curSubmitBtn.addClass(
                                    "disabledByFormValidation"
                                );
                            }
                        });

                        $.ajax({
                            method:
                                base.method === "GET" || base.method === "get"
                                    ? "GET"
                                    : "POST",
                            url: base.url,
                            dataType: "json",
                            data: data,
                            redirLogout: true /* redirect in case logged out (redirect-proxy.js) */,
                            success: function(data) {
                                selectedDisabledOptions.prop("disabled", true);
                                base.handleFormResponse(
                                    submitForm,
                                    data,
                                    isValid_Radiogroups
                                );
                                disabledVisibleInputs.prop("disabled", true);
                            },
                            error: function() {
                                // if ajax call fails somehow, try to submit data anyway
                                base.submitBtn.prop("disabled", false);

                                if (
                                    submitForm.tagName.toUpperCase() === "FORM"
                                ) {
                                    submitForm.submit();
                                }
                                selectedDisabledOptions.prop("disabled", true);
                                disabledVisibleInputs.prop("disabled", true);
                            }
                        });
                    }
                });
            },

            handleFormResponse: function(
                submitForm,
                data,
                isValid_Radiogroups
            ) {
                var base = this;

                if (typeof data.validation !== "undefined") {
                    if (
                        typeof data.validation === "string" &&
                        data.validation.toUpperCase() === "OK"
                    ) {
                        base.onGtmFormValidEnabledAddEventDataToGtmDatalayer(
                            submitForm,
                            "data-gtm-formvalid-enabled",
                            "data-gtm-formvalid-datalayer"
                        );

                        if (isValid_Radiogroups) {
                            submitForm.submit();
                            return;
                        }
                    }
                    // in case of (unexpected) return of text message other than 'OK' or 'false'
                    else if (
                        typeof data.validation === "string" &&
                        data.validation !== "false"
                    ) {
                        var messageHandler = new ZZ.MessageHandler(
                            $(submitForm)
                        );
                        messageHandler.showMessage(data.validation);

                        console.log(submitForm);

                        if (submitForm) {
                            var formElement =
                                submitForm instanceof jQuery
                                    ? submitForm.get(0)
                                    : submitForm;
                            var formInputElement = formElement.querySelector(
                                "input"
                            );
                            if (formInputElement) {
                                base.addGtmErrorEventDataOnChangedValue(
                                    formElement,
                                    formInputElement
                                );
                            }
                        }
                    }
                    // in case of object containing field names and error messages
                    else {
                        base.validateMultipleFields(data.validation);
                    }

                    // enable submit button if disabled by form validation script
                    var curSubmitBtn;
                    base.submitBtn.each(function() {
                        curSubmitBtn = $(this);
                        if (curSubmitBtn.hasClass("disabledByFormValidation")) {
                            curSubmitBtn.removeClass(
                                "disabledByFormValidation"
                            );
                            if (
                                curSubmitBtn
                                    .attr("class")
                                    .indexOf("disabledBy") === -1
                            ) {
                                curSubmitBtn.prop("disabled", false);
                            }
                        }
                    });
                }

                // custom event for attaching additional actions when form not valid
                $(submitForm).trigger("ZZ_form-invalid");

                var errors = base.form.find(
                    ".information-edit.error, .input-wrapper.error"
                );
                // no form errors
                if (errors.length === 0) {
                    return true;
                }
                // errors
                else {
                    // scroll to first error on form
                    $("html, body").animate(
                        {
                            scrollTop: $(errors[0]).offset().top - 15
                        },
                        200
                    );

                    // remove validation from error field if field is changed
                    errors.find("input").one("change", function() {
                        base.removeFieldValidation($(this));
                    });

                    return false;
                }
            },

            onGtmFormValidEnabledAddEventDataToGtmDatalayer: function(
                formElement,
                dataGtmAttributeEnabled,
                dataGtmAttributeDatalayer
            ) {
                var base = this;
                var dataGtmFormValidEnabledAttribute = formElement.getAttribute(
                    dataGtmAttributeEnabled
                );
                if (dataGtmFormValidEnabledAttribute) {
                    var dataGtmFormValidationDatalayer = JSON.parse(
                        formElement.getAttribute(dataGtmAttributeDatalayer)
                    );
                    base.registerOnGtmDatalayer(dataGtmFormValidationDatalayer);
                }
            },

            addGtmErrorEventDataOnChangedValue: function(
                targetMessageNode,
                inputValue
            ) {
                var base = this;
                if (
                    targetMessageNode &&
                    base.isEmptyOrNonSimilarValue(inputValue)
                ) {
                    base.onGtmFormValidEnabledAddEventDataToGtmDatalayer(
                        targetMessageNode,
                        "data-gtm-formvalid-enabled",
                        "data-gtm-formvalid-error-datalayer"
                    );
                    base.previousInvalidFieldValue = inputValue;
                    base.previousInvalidFieldTrigger = true;
                }
            },

            isEmptyOrNonSimilarValue: function(inputValue) {
                var base = this;
                return (
                    (inputValue.length === 0 &&
                        base.previousInvalidFieldTrigger === false) ||
                    base.previousInvalidFieldValue !== inputValue
                );
            },

            registerOnGtmDatalayer: function(gtmEventData) {
                if (gtmEventData !== undefined && gtmEventData !== null) {
                    if (window["dataLayer"]) {
                        window["dataLayer"].push(gtmEventData);
                    }
                }
            },

            transformBeforeValidate: function(input) {
                if (
                    typeof input.attr("data-validate-transform-birthdate") !==
                    "undefined"
                ) {
                    this.transformBeforeValidate_birthdate(input);
                } else if (
                    typeof input.attr("data-validate-transform-date") !==
                    "undefined"
                ) {
                    this.transformBeforeValidate_date(input);
                }
            },

            transformBeforeValidate_birthdate: function(input) {
                var regex = /^(0[1-9]|1[0-9]|2[0-9]|3[0-1]|[0-9]\D+)\D*(0[1-9]|1[0-2]|[0-9]\D+)\D*(19\d{2}|20\d{2}|\d{2})$/i;
                this.transformBeforeValidate_date(input, false, regex);
            },

            transformBeforeValidate_date: function(input, future, regex) {
                var i;
                var dateString = input.val();
                var default_regex = /^(0[1-9]|1[0-9]|2[0-9]|3[0-1]|[0-9]\D+)\D*(0[1-9]|1[0-2]|[0-9]\D+)\D*(20\d{2}|\d{2}|\d{4})$/i;

                future =
                    typeof future === "undefined" && future !== null
                        ? true
                        : false;
                regex =
                    typeof regex === "undefined" && regex !== null
                        ? default_regex
                        : regex;

                var matches = dateString.match(regex);

                if (matches !== null && matches && matches.length === 4) {
                    for (i = 1; i <= 4; i++) {
                        matches[i] = parseInt(matches[i]);
                        if (matches[i] <= 9) {
                            matches[i] = "0" + matches[i];
                        }
                    }
                    // year
                    if (("" + matches[3]).length === 2) {
                        if (
                            !future &&
                            matches[3] >
                                +("" + new Date().getFullYear()).substr(2, 2)
                        ) {
                            matches[3] = "19" + matches[3];
                        } else {
                            matches[3] = "20" + matches[3];
                        }
                    }
                    input.val(matches[1] + "-" + matches[2] + "-" + matches[3]);
                }
            },

            validateField: function(input) {
                var base = this,
                    $form = $(input).parents("form"),
                    requestMethod = "POST",
                    parameters =
                        "fieldname=" +
                        encodeURIComponent(input.attr("name")) +
                        "&fieldvalue=" +
                        encodeURIComponent(input.val());

                if (!base.url) {
                    base.url = $form.attr("data-validation-url");
                }
                // no single field validation for autocomplete when dropdown is open
                if ($(".ui-autocomplete").is(":visible")) {
                    return;
                }
                //optie om van een standaard get een post te maken
                if (
                    typeof input.attr("data-validate-requestmethod") !==
                    "undefined"
                ) {
                    requestMethod = input
                        .attr("data-validate-requestmethod")
                        .toUpperCase();
                } else if (typeof $form.attr("method") !== "undefined") {
                    requestMethod = $form.attr("method").toUpperCase();
                }

                //er moet ZZCSRFToken meegestuurd worden met post naar de serever
                var securityToken = $(":input[name=ZZCSRFToken]:first");
                if (securityToken.length > 0 && requestMethod === "POST") {
                    parameters += "&" + securityToken.serialize();
                }
                // no single field validation for checkboxes and radiobuttons or when selected option is disabled
                if (
                    typeof input.attr("data-validate") === "undefined" ||
                    input.attr("type") === "checkbox" ||
                    input.attr("type") === "radio" ||
                    input.find(":selected").prop("disabled") === true
                ) {
                    return;
                }

                $.ajax({
                    url: base.url,
                    dataType: "json",
                    type: requestMethod,
                    data: parameters,
                    redirLogout: true /* redirect in case logged out (redirect-proxy.js) */,
                    success: function(response) {
                        var valid = response.validation;
                        if (
                            typeof valid === "string" &&
                            valid.toUpperCase() === "OK"
                        ) {
                            base.fieldIsValid(input);
                        } else {
                            base.fieldIsInvalid(input, valid);
                        }
                        input.trigger("ZZ_validate_done");
                    }
                });
            },

            fieldIsValid: function(input) {
                var base = this,
                    inputWrapper = input.parent();

                inputWrapper.removeClass(base._defaultConfig.invalidClassName);
                inputWrapper.addClass(base._defaultConfig.validClassName);
                input.removeClass(base._defaultConfig.invalidClassName);
                input.addClass(base._defaultConfig.validClassName);

                $(input)
                    .parents("form")
                    .removeClass(base._defaultConfig.invalidClassName);
                $(input)
                    .parents("form")
                    .addClass(base._defaultConfig.validClassName);
            },

            fieldIsInvalid: function(input, message) {
                var base = this,
                    inputWrapper = input.parent(),
                    messageNode = inputWrapper.find(".validation-message");

                if (messageNode && input) {
                    base.addGtmErrorEventDataOnChangedValue(
                        messageNode.get(0),
                        input.val()
                    );
                }

                if (messageNode.length === 0) {
                    messageNode = $('<p class="validation-message"></p>');
                    inputWrapper.append(messageNode);
                }
                messageNode.html(message);
                inputWrapper.removeClass(base._defaultConfig.validClassName);
                inputWrapper.addClass(base._defaultConfig.invalidClassName);
                input.removeClass(base._defaultConfig.validClassName);
                input.addClass(base._defaultConfig.invalidClassName);
                $(input)
                    .parents("form")
                    .removeClass(base._defaultConfig.validClassName);
                $(input)
                    .parents("form")
                    .addClass(base._defaultConfig.invalidClassName);
            },

            removeFieldValidation: function(input) {
                var base = this,
                    inputWrapper = input.parent(),
                    form = input.closest("form"),
                    messageNode = inputWrapper.find(".validation-message");

                input.removeClass(
                    base._defaultConfig.invalidClassName +
                        " " +
                        base._defaultConfig.validClassName
                );
                inputWrapper.removeClass(
                    base._defaultConfig.invalidClassName +
                        " " +
                        base._defaultConfig.validClassName
                );
                if (form.find("input.error").length === 0) {
                    form.removeClass(
                        base._defaultConfig.invalidClassName +
                            " " +
                            base._defaultConfig.validClassName
                    );
                }
                messageNode.html("");
            },

            // fieldMessages JSON structure: {"validation": [{"fieldname": "<fieldname>", "fieldmessage": "<message>"}, etc.]}
            validateMultipleFields: function(fieldMessages) {
                var base = this,
                    fields = fieldMessages,
                    field,
                    i = 0,
                    fieldsLength = fields.length;

                for (i; i < fieldsLength; i++) {
                    field = $('[name="' + fields[i].fieldname + '"]');
                    base.fieldIsInvalid(field, fields[i].fieldmessage);
                }

                base.validateCheckboxGroups();
            },

            reInit: function(input) {
                this.inputs.off("blur.validate");
                this.inputs = this.form.find("input[data-validate]");
                this.assignListeners();
            },

            handleExclusionConditions: function(inputs) {
                var base = this,
                    listLength = inputs.length,
                    exclusionHandlers = [];

                var curInput,
                    curExceptions,
                    curException,
                    curTrigger,
                    curAction,
                    i,
                    j;

                for (i = 0; i < listLength; i++) {
                    curInput = $(inputs[i]);
                    curExceptions = curInput
                        .attr("data-only-validate-if")
                        .split("||");
                    exclusionHandlers[curInput.attr("name")] = [];
                    for (j = 0; j < curExceptions.length; j++) {
                        curException = curExceptions[j].split("=");
                        if (curException.length > 1) {
                            curTrigger = $(curException[0]);
                            curAction = curException[1];
                        } else {
                            curTrigger = curInput;
                            curAction = curException[0];
                        }

                        // add new exclusion handler for specific condition
                        exclusionHandlers[curInput.attr("name")].push(
                            new ZZ.ExclusionConditionHandler(
                                curInput,
                                curTrigger,
                                curAction,
                                base.config
                            )
                        );
                    }
                }
            },

            validateRadioGroups: function() {
                var base = this,
                    datavalidateradiogroups = base.form.find(
                        "[data-validate-radiogroup]"
                    ),
                    result = true;

                datavalidateradiogroups.each(function(index, elem) {
                    var curGroup = $(elem);

                    if (
                        curGroup.find(":checked").length === 0 &&
                        !curGroup.is(":hidden")
                    ) {
                        base.fieldIsInvalid(
                            curGroup.find("input:first"),
                            base._defaultConfig.invalidRadiogroupText
                        );
                        result = false;
                    }
                });

                return result;
            },

            validateCheckboxGroup: function(index, element) {
                var errorMessagelist = $(element).find(".validation-message");
                for (
                    var i = 0, len = errorMessagelist.length - 1;
                    i < len;
                    i++
                ) {
                    $(errorMessagelist[i]).remove();
                }
            },

            validateCheckboxGroups: function() {
                var base = this,
                    checkboxgroups;
                if (base.checkboxgroups) {
                    base.checkboxgroups.each(base.validateCheckboxGroup);
                }
            }
        };

        /** ExclusionConditionHandler
         * Object to handle conditions in which validations on an input field are not needed
         * (submitted on field using the data-only-validate-if attribute)
         */
        ZZ.ExclusionConditionHandler = function(
            input,
            trigger,
            action,
            config
        ) {
            var base = this;
            base.input = input;
            base.trigger = trigger;
            base.watch = trigger;
            base.action = action;
            base.config = config;

            // in case of radiobutton, get the radiogroup
            if (base.trigger.attr("type") === "radio") {
                base.trigger = $("[name=" + base.trigger.attr("name") + "]");
            }

            base.assignListeners();

            // trigger init event on page load
            base.trigger.trigger("init");
        };

        ZZ.ExclusionConditionHandler.prototype = {
            assignListeners: function() {
                var base = this;

                base.trigger.on("change init", function() {
                    switch (base.action) {
                        case ">14days":
                            // TODO (improvement) - get these values from action string
                            var years = 0,
                                months = 0,
                                days = 14;

                            var selectedDate = base.trigger.datepicker(
                                    "getDate"
                                ),
                                today = new Date(),
                                thresholdDate = new Date(
                                    today.getFullYear() - years,
                                    today.getMonth() - months,
                                    today.getDate() - days
                                );

                            selectedDate > thresholdDate
                                ? base.removeValidation(true)
                                : base.addValidation(true);

                            break;

                        case "not_empty":
                            if ($.trim(base.trigger.val()) === "") {
                                base.removeValidation(false);
                            } else {
                                base.addValidation(false);
                            }
                            break;

                        default:
                            if (base.trigger.is(":radio")) {
                                if (base.watch.is(":checked")) {
                                    base.addValidation(true);
                                } else {
                                    base.removeValidation(true);
                                }
                            } else if (base.trigger.val() === base.action) {
                                base.addValidation(true);
                            } else {
                                base.removeValidation(true);
                            }
                            break;
                    }
                });
            },

            removeValidation: function(mandatory) {
                var base = this;

                base.input.removeAttr("data-validate");
                base.input
                    .closest(".information-edit")
                    .removeClass(
                        base.config.invalidClassName +
                            " " +
                            base.config.validClassName
                    );
                base.input.removeClass(
                    base.config.invalidClassName +
                        " " +
                        base.config.validClassName
                );
                base.input
                    .closest("form")
                    .removeClass(
                        base.config.invalidClassName +
                            " " +
                            base.config.validClassName
                    );
                if (mandatory) {
                    var mandatorySymbol = $(
                        "label[for=" + base.input.attr("id") + "]"
                    );
                    // uncertain backup in case matching label for attribute selector fails
                    if (mandatorySymbol.length === 0) {
                        mandatorySymbol = base.input
                            .closest(".information-edit")
                            .prev("label");
                    }
                    mandatorySymbol.find("span").hide();
                }
            },

            addValidation: function(mandatory) {
                var base = this;

                base.input.attr("data-validate", "true");
                if (mandatory) {
                    var mandatorySymbol = $(
                        "label[for=" + base.input.attr("id") + "]"
                    );
                    // backup in case matching label for attribute selector fails
                    if (mandatorySymbol.length === 0) {
                        mandatorySymbol = base.input
                            .closest(".information-edit")
                            .prev("label");
                    }
                    mandatorySymbol.find("span").show();
                }
            }
        };

        /** ZZ validation handler
         * Mini-handler for handling custom validation errors on input fields
         *
         */
        ZZ.FormValidationHandler = function() {
            var base = this;

            base.config = {
                invalidClassName: "error",
                validClassName: "accord"
            };
        };

        ZZ.FormValidationHandler.prototype = {
            fieldIsValid: function(input) {
                var base = this,
                    inputWrapper = input.parent(),
                    form = input.closest("form"),
                    messageNode = inputWrapper.find(".validation-message");

                inputWrapper.removeClass(base.config.invalidClassName);
                inputWrapper.addClass(base.config.validClassName);
                input.removeClass(base.config.invalidClassName);
                input.addClass(base.config.validClassName);
                form.removeClass(base.config.invalidClassName);
                form.addClass(base.config.validClassName);
                if (form.find("input.error").length === 0) {
                    form.removeClass(base.config.validClassName);
                    form.addClass(base.config.invalidClassName);
                }
                messageNode.html("");
            },

            fieldIsInvalid: function(input, message) {
                var base = this,
                    inputWrapper = input.parent(),
                    form = input.closest("form"),
                    messageNode = inputWrapper.find(".validation-message");

                if (messageNode.length === 0) {
                    messageNode = $('<p class="validation-message"></p>');
                } else {
                    messageNode.detach();
                }

                messageNode.html(message);
                inputWrapper.append(messageNode);

                inputWrapper.removeClass(base.config.validClassName);
                inputWrapper.addClass(base.config.invalidClassName);
                input.removeClass(base.config.validClassName);
                input.addClass(base.config.invalidClassName);
            },

            removeFieldValidation: function(input) {
                var base = this,
                    inputWrapper = input.parent(),
                    form = input.closest("form"),
                    messageNode = inputWrapper.find(".validation-message");

                input.removeClass(
                    base.config.invalidClassName +
                        " " +
                        base.config.validClassName
                );
                inputWrapper.removeClass(
                    base.config.invalidClassName +
                        " " +
                        base.config.validClassName
                );
                if (form.find("input.error").length === 0) {
                    form.removeClass(
                        base.config.invalidClassName +
                            " " +
                            base.config.validClassName
                    );
                }
                messageNode.html("");
            },

            reAssignValidationListeners: function(container) {
                container
                    .find("input")
                    .not(".hasDatepicker, select")
                    .on("blur.validate", function() {
                        ZZ.FormValidation.prototype.validateField($(this));
                    });
            }
        };
    })(jQuery);
}
